export const CREATE_PROSPECT = `
  mutation createProspect($input: CreateProspectInput!, $tenant_id: Int!) {
    createProspect(input: $input, tenant_id: $tenant_id) {
      __typename
      ... on Prospect {
        id
        contact_id
        chair_id
        contact {
          id
          firstname
          lastname
          email
        }
        chair {
          id
          contact_id
          contact {
            id
            firstname
            lastname
          }
        }
        its
        uts
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const CREATE_PROSPECT_WITH_CONTACT = `
  mutation createProspectWithContact(
    $input: CreateProspectWithContactInput!
    $tenant_id: Int!
  ) {
    createProspectWithContact(input: $input, tenant_id: $tenant_id) {
      __typename
      ... on Prospect {
        id
        contact_id
        chair_id
        contact {
          id
          firstname
          lastname
          email
          company_id
          company {
            id
            name
            cuit
            province_id
            city
          }
        }
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const UPDATE_PROSPECT = `
  mutation updateProspect($input: UpdateProspectInput!, $tenant_id: Int!) {
    updateProspect(input: $input, tenant_id: $tenant_id) {
      __typename
      ... on Prospect {
        id
        contact_id
        chair_id
        contact {
          id
          firstname
          lastname
          email
        }
        chair {
          id
          contact_id
          contact {
            id
            firstname
            lastname
          }
        }
        its
        uts
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const DELETE_PROSPECT = `
  mutation deleteProspect($id: Int!, $tenant_id: Int!) {
    deleteProspect(id: $id, tenant_id: $tenant_id) {
      __typename
      ... on Prospect {
        id
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
